<template>
<v-app style="padding-top:140px;background-color:white">
  <div style="padding-top:10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#7FB4FD" class="txt">Refund Policy</span></p>
     </div>
    <v-container>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card flat class="container">
                <p style="font-size:16px" class="txt">
                 Full refund will be given, if the claim is found to be valid, in following cases:<br/>
•	Defective or Damaged product<br/>
•	Cancelled Order<br/>
The mode of refund will be by way of credit to the original mode of payment – Credit/Debit Card, or 
Net banking or Third Party Wallet.<br/><br/>
Please allow 7 to 15 working days for the credit to appear in your account.
While we regret any inconvenience caused by this time frame, it is the bank's 
policy that delays the refund timing and we have no control over that.<br/><br/>
In case of any query related to refund, please call our customer service desk at +91 6289408122 or email us at info@csquad.in

                </p>
            </v-card>
        </v-flex>
    </v-layout>
    </v-container>
    
</v-app>
</template>

<script>
import config from "./../../config.json";

export default {
  data() {
    return {
      search: "",
      orderDialog: false,
      deactive: false,
      btnSave: false,
      btnSave1: false,
      address: [],
      addressDialog: false,
      valid: true,
      selectedAddress: {
        id: null,
        name: null,
        mobileNumber: null,
        address: null,
        pinCode: null
      },
      selectedAddress1: null,

      form: {
        name: null,
        mobileNumber: null,
        pinCode: null,
        address: null,
        landMark: null,
        locality: null,
        cityDistrictTown: null,
        alternateNumber: null
      },

      selected: "Home Address",
      options: ["Home Address", "Office Address"],

      selected1: "Cash on Delivery",
      options1: ["Cash on Delivery", "Online Payment"],

      states: [],
      selectedState: null,

      headers: [
        { text: "PRODUCT", value: "name" },
        { text: "REMOVE", value: "remove" }
      ],
      homePage: {
        productCategoryList: null,
      },
      orderDetails: this.$store.state.wish,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
  },

  methods: {
    productDetail(item) {
     this.$router.push(`/productDetail/` + item.itemId);
    },
    cart(item) {
     this.$store.commit('addToCart', item);
   },
   minuscart(item) {
     this.$store.commit('minusToCart', item);
   },
    removeFromWish(item) {
        this.$store.commit('removeFromWish', item);
    },

    category(cus) {
      this.$router.push("/categoryDetail/" + cus.id);
    },
    home(){
      this.$router.push(`/demo`);
    },

    proceed() {
      if (sessionStorage.loggedInUserID != null) {
        if(this.selectedAddress.id == null || this.selectedAddress.id == 'undefined') {
          this.addressDialog = true;
        }
        else {
          this.btnSave = true;
        this.axios
          .post(
            config.API + `Orders`,
            {
              addressId: JSON.parse(this.selectedAddress.id),
              totalPrice: JSON.parse(this.totalPrice),
              paymentType: this.selected1,
              orderDetails: this.orderDetails
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Order Successfully placed");
            this.$store.commit('count');
            this.orderDialog = true;
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
        }
      }
      else {
        this.$router.push("/login");
      }
    },

    getData() {
      if(sessionStorage.loggedInUserID != null) {
        this.axios
        .get(config.API + "CustomerAddresses/" + 1, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.selectedAddress.id = res.data.id;
          this.selectedAddress.name = res.data.name;
          this.selectedAddress.mobileNumber = res.data.mobileNumber;
          this.selectedAddress.address = res.data.address;
          this.selectedAddress.pinCode = res.data.pinCode;
        })
      }
    },

    getData1() {
      this.axios
        .get(config.API + "CustomerAddresses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.address = res.data;
        });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave1 = true;
        this.axios
          .post(
            config.API + `CustomerAddresses`,
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              pinCode: JSON.parse(this.form.pinCode),
              address: this.form.address,
              locality: this.form.locality,
              cityDistrictTown: this.form.cityDistrictTown,
              landMark: this.form.landMark,
              alternateNumber: this.form.alternateNumber,
              stateCode: JSON.parse(this.selectedState),
              addressType: this.selected
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            this.getData1();
            this.getData();
            this.btnSave1 = false;
            this.addressDialog = false;
          })
          .catch(err => {
            this.$toaster.error('"wong');
            this.btnSave1 = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    changeAddress() {
      this.selectedAddress.id = this.selectedAddress1.id;
      this.selectedAddress.name = this.selectedAddress1.name;
      this.selectedAddress.mobileNumber = this.selectedAddress1.mobileNumber;
      this.selectedAddress.address = this.selectedAddress1.address;
      this.selectedAddress.pinCode = this.selectedAddress1.pinCode;
      this.addressDialog = false;
    }
},

mounted() {
   this.getData();
   this.getData1();

        this.axios
        .get(config.API + "States", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
        });
  },

  computed: {
    totalPrice() {
        let total = 0;

        for (let item of this.$store.state.cart) {
            total += item.totalPrice;
        }

        return total.toFixed(2);
    }
}
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>
<style>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-size: 12px;
  font-weight: bold;
  margin: 0px;
}
.covid1 {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.point {
  cursor:pointer !important;
}
.bgc {
    background-color:#eeeeee !important;
}
</style>
